import React from 'react';
import AuthContainer, { classes } from './_styles';

export const AuthLayoutClasses = classes;

const AuthLayout: React.FunctionComponent = ({ children }) => {
  return <AuthContainer>{children}</AuthContainer>;
};
export default AuthLayout;
